import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Box, useMediaQueries } from '@honda-canada/design-system-react';
import DealerDetailsHeader from './DealerDetailsHeader';
import { DealersListContext } from '../DealersListContext';
import themeStyles from './DealerDetailsModal.style';
import useFocus from '../../hooks/useFocus';

const DealerModal = themeStyles.apply(Box, 'DealerModal');

const DealerDetailsModal = ({ dealer, modalWidth, children, isFullScreenModal, setFullScreenModal, withoutArrow }) => {
  const { isDealerModalOpen, setDealerModalOpen, setSelectedDealer } = useContext(DealersListContext);
  const { isDesktop } = useMediaQueries();
  const [addHtmlElRef, setFocus] = useFocus();

  if (!isDealerModalOpen) return null;

  setFocus(dealer.code);
  const onCloseClick = () => {
    // de-select current dealer upon closing the modal
    setSelectedDealer(null);
    setDealerModalOpen(false);
    setFullScreenModal(false);
    setFocus(null);
  };
  const modalHeight = isDealerModalOpen && isDesktop ? '100vh' : 'auto';
  return (
    <DealerModal
      key={dealer?.code}
      withoutArrow={withoutArrow}
      isFullScreenModal={isFullScreenModal}
      modalHeight={modalHeight}
      modalWidth={modalWidth}
      data-testid="cy-dealer-details-modal"
      tabIndex="0"
      ref={addHtmlElRef(dealer?.code)}
    >
      <DealerDetailsHeader dealer={dealer} onCloseClick={onCloseClick} />
      {children}
    </DealerModal>
  );
};

DealerDetailsModal.defaultProps = {
  dealer: {},
  isFullScreenModal: false,
  setFullScreenModal: () => {},
  withoutArrow: false,
};

DealerDetailsModal.propTypes = {
  dealer: PropTypes.shape({
    name: PropTypes.string,
    drivingDistance: PropTypes.number,
    code: PropTypes.string,
  }),
  children: PropTypes.node,
  modalWidth: PropTypes.string,
  isFullScreenModal: PropTypes.bool,
  setFullScreenModal: PropTypes.func,
  withoutArrow: PropTypes.bool,
};

export default DealerDetailsModal;
